/* eslint-disable */
import React, {Component} from 'react'
import http from '../Interceptor/Interseptor'
import {DatePicker, MuiPickersUtilsProvider} from 'material-ui-pickers'
import JalaliUtils from 'material-ui-pickers-jalali-utils'
import moment from 'moment'
import jMoment from 'moment-jalaali'
import Loader from '../loaders/loader'
import {Icon, message} from 'antd'
import {Modal, ModalBody, ModalFooter, ModalHeader} from 'mdbreact'
import CRM from './CRM'
import Pageing from '../Pagination/pageing'
class ParcelSearch extends Component {
  constructor(props) {
    super(props)
    this.state = {
      modal: false,
      orderDate: null,
      orderDateTo: null,
      deliveryDate: null,
      deliveryDateTo: null,
      invoiceId: null,
      invoiceNum: null,
      customerCode: null,
      result: [],
      pageSize: 10,
      pageNumber: 1,
      countAll: 0,
      parcelId: ''
    }
  }

  componentDidMount() {
    if (this.props.value) {
      this.setState(
        {
          parcelId: this.props.value
        },
        () => {
          this.props.setParcel(this.props.value)
        }
      )
    }
  }

  handleOrderDate = (date) => {
    this.setState({orderDate: date})
  }

  handleOrderDateTo = (date) => {
    this.setState({orderDateTo: date})
  }

  handleDeliveryDate = (date) => {
    this.setState({deliveryDate: date})
  }

  handleDeliveryDateTo = (date) => {
    this.setState({deliveryDateTo: date})
  }

  changeField = (e) => {
    let name = e.target.name
    this.setState({
      [name]: e.target.value
    })
  }

  showModal = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  searchParcel = () => {}

  orderDateEl(props) {
    return <input className="form-control" {...props} />
  }

  orderDateElTo(props) {
    return <input className="form-control" {...props} />
  }

  deliveryDateEl(props) {
    return <input className="form-control" {...props} />
  }

  deliveryDateElTo(props) {
    return <input className="form-control" {...props} />
  }

  epochFromModal = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let from = miladiDate + ' ' + '00:00'
    let fromEpoch = moment.utc(from).valueOf()
    return fromEpoch - 3.5 * 3600 * 1000
  }

  epochToModal = (x) => {
    let miladiDate = jMoment(x, 'jYYYY/jM/jD').format('YYYY/M/D')
    let to = miladiDate + ' ' + '23:59:59'
    let toEpoch = moment.utc(to).valueOf()
    return toEpoch - 3.5 * 3600 * 1000
  }

  convertDigit = (string) => {
    return string
      .replace(/[\u0660-\u0669]/g, function(c) {
        return c.charCodeAt(0) - 0x0660
      })
      .replace(/[\u06f0-\u06f9]/g, function(c) {
        return c.charCodeAt(0) - 0x06f0
      })
  }

  search = () => {
    let {invoiceId, invoiceNum, customerCode, pageNumber, pageSize} = this.state
    let registerDate = this.convertDigit(document.getElementById('registerDate').value)
    let registerDateTo = this.convertDigit(document.getElementById('registerDateTo').value)
    let deliveryDate = this.convertDigit(document.getElementById('deliveryDate').value)
    let deliveryDateTo = this.convertDigit(document.getElementById('deliveryDateTo').value)

    if (!invoiceId && !invoiceNum && !customerCode) {
      message.error('حداقل فیلتر شناسه فاکتور یا شماره فاکتور یا کد مشتری وارد شود')
    } else {
      const params = {
        invoiceId,
        invoiceNum,
        customerCode,
        deliveryDateMin: deliveryDate ? this.epochFromModal(deliveryDate) : null,
        deliveryDateMax: deliveryDateTo ? this.epochFromModal(deliveryDateTo) : null,
        registerDateMin: registerDate ? this.epochFromModal(registerDate) : null,
        registerDateMax: registerDateTo ? this.epochFromModal(registerDateTo) : null,
        pageNumber,
        pageSize,
        export: false,
        sortBy: 'regDate_desc'
      }
      this.setState({loading: true})
      http
        .get(`crm/contact/search/customer/delivery-pack`, {
          params
        })
        .then((res) => {
          this.setState({
            loading: false
          })
          if (!res.data.error) {
            this.setState({
              result: res.data.object.result,
              countAll: res.data.object.countAll
            })
          } else {
          }
        })
        .catch(() => {})
    }
  }

  getPageNumber = (pageNumber) => {
    this.setState(
      {
        pageNumber
      },
      () => {
        this.search()
      }
    )
  }

  selectParcel = (customer) => {
    this.setState(
      {
        parcelId: customer.deliveryPackId,
        modal: false
      },
      () => {
        this.props.setParcel(customer.deliveryPackId)
      }
    )
  }

  remove = () => {
    this.setState(
      {
        parcelId: ''
      },
      () => {
        this.props.setParcel('')
      }
    )
  }

  render() {
    const {label, value, required} = this.props
    return (
      <div className="position-relative">
        <label>
          {label}
          {required ? <span class="text-danger">*</span> : null}
        </label>
        <div class="input-group position-relative mb-3">
          {/* {value ? (
            <div class="input-group-prepend">
              <span class="input-group-text" id="basic-addon1">
                {value}
              </span>
            </div>
          ) : null} */}

          <input type="text" class="form-control" value={this.state.parcelId} onClick={this.showModal} readOnly />
          {value ? (
            <img
              onClick={() => this.remove()}
              src={require('../../image/close.svg')}
              style={{
                width: 20,
                position: 'absolute',
                top: '15%',
                left: 5,
                zIndex: 100,
                cursor: 'pointer',
                transform: 'translateY(20%)'
              }}
            />
          ) : null}
        </div>
        <Modal isOpen={this.state.modal} toggle={() => console.log('toggle')} size="lg">
          <ModalHeader toggle={() => console.log('')}>جست و جوی فاکتور</ModalHeader>
          <ModalBody>
            <Loader show={this.state.loading} />
            <div className="modalForm searchProduct">
              <figure>
                <label>شناسه فاکتور : </label>
                <input
                  type="text"
                  onChange={this.changeField}
                  defaultValue={this.state.invoiceId}
                  name="invoiceId"
                  className="form-control"
                  id="input_CustomerInvoiceId"
                />
              </figure>
              <figure>
                <label>شماره فاکتور : </label>
                <input
                  type="text"
                  onChange={this.changeField}
                  defaultValue={this.state.invoiceNum}
                  name="invoiceNum"
                  className="form-control"
                  id="invoiceNum"
                />
              </figure>

              <figure>
                <label>کد مشتری : </label>
                <input
                  type="text"
                  onChange={this.changeField}
                  defaultValue={this.state.customerCode}
                  name="customerCode"
                  className="form-control"
                  id="customerCodeByInvoice"
                />
              </figure>
              <figure>
                <label>تاریخ سفارش از : </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    labelFunc={(orderDate) => (orderDate == null ? '' : orderDate.format('jYYYY/jMM/jDD'))}
                    onChange={this.handleOrderDate}
                    TextFieldComponent={this.orderDateEl}
                    id="registerDate"
                    name="registerDate"
                    value={this.state.orderDate}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </figure>

              <figure>
                <label>تاریخ سفارش تا : </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    labelFunc={(orderDateTo) => (orderDateTo == null ? '' : orderDateTo.format('jYYYY/jMM/jDD'))}
                    onChange={this.handleOrderDateTo}
                    TextFieldComponent={this.orderDateElTo}
                    id="registerDateTo"
                    name="registerDateTo"
                    value={this.state.orderDateTo}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </figure>
              <figure>
                <label>تاریخ تحویل از : </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    labelFunc={(deliveryDate) => (deliveryDate == null ? '' : deliveryDate.format('jYYYY/jMM/jDD'))}
                    onChange={this.handleDeliveryDate}
                    TextFieldComponent={this.deliveryDateEl}
                    id="deliveryDate"
                    name="deliveryDate"
                    value={this.state.deliveryDate}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </figure>

              <figure>
                <label>تاریخ تحویل تا : </label>
                <MuiPickersUtilsProvider utils={JalaliUtils} locale="fa">
                  <DatePicker
                    okLabel="تأیید"
                    cancelLabel="لغو"
                    autoOk={true}
                    leftArrowIcon={<Icon type="left" />}
                    rightArrowIcon={<Icon type="right" />}
                    labelFunc={(deliveryDateTo) =>
                      deliveryDateTo == null ? '' : deliveryDateTo.format('jYYYY/jMM/jDD')
                    }
                    onChange={this.handleDeliveryDateTo}
                    TextFieldComponent={this.deliveryDateElTo}
                    id="deliveryDateTo"
                    name="deliveryDateTo"
                    value={this.state.deliveryDateTo}
                    readOnly
                  />
                </MuiPickersUtilsProvider>
              </figure>
            </div>
            <div className="container-fluid">
              <div className="row justify-content-between">
                <div className="col-6 text-left">
                  <button className="confirmBtnModal" onClick={this.search}>
                    جستجو
                  </button>
                </div>
                <div className="col-6 text-right">
                  <button className="cancelBtnModal" onClick={() => this.setState({modal: false})}>
                    بستن
                  </button>
                </div>
              </div>
            </div>
            {this.state.result.length > 0 ? (
              <div className="container-fluid mt-3">
                <table className="table table-bordered table-striped table-sm w-100">
                  <thead>
                    <tr>
                      <td className="align-middle">ردیف</td>
                      <td>#</td>
                      <td>نام</td>
                      <td>شناسه مرسوله</td>
                      <td>شناسه فاکتور</td>
                      <td>شماره فاکتور</td>
                      <td>کد مشتری</td>
                      <td>موبایل</td>
                      <td>تاریخ ثبت</td>
                      <td>تاریخ تحویل</td>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.result.map((customer, index) => (
                      <tr>
                        <td className="align-middle text-center">
                          {(this.state.pageNumber - 1) * this.state.pageSize + index + 1}
                        </td>
                        <td className="align-middle text-center">
                          <button
                            className="btn btn-sm"
                            style={{color: '#000', fontWeight: '600'}}
                            onClick={() => this.selectParcel(customer)}
                          >
                            انتخاب
                          </button>
                        </td>
                        <td className="align-middle text-center">{customer.buyerFullName}</td>
                        <td className="align-middle text-center">{customer.deliveryPackId}</td>
                        <td className="align-middle text-center">{customer.invoiceId}</td>
                        <td className="align-middle text-center">{customer.invoiceNum}</td>
                        <td className="align-middle text-center">{customer.code}</td>
                        <td className="align-middle text-center">{customer.phoneNumber}</td>
                        <td className="align-middle text-center">
                          {customer.regDate !== null && jMoment(customer.regDate).format('jYYYY/jMM/jDD HH:mm')}
                        </td>
                        <td className="align-middle text-center">
                          {customer.deliveryDate == null
                            ? '-'
                            : jMoment(customer.deliveryDate).format('jYYYY/jMM/jDD HH:mm')}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                <div className="paginationWrapp">
                  <Pageing
                    defaultCurrent={1}
                    getPage={this.getPageNumber}
                    pageSize={this.state.pageSize}
                    currentPage={this.state.pageNumber}
                    total={this.state.countAll}
                  />
                </div>
              </div>
            ) : null}
          </ModalBody>
        </Modal>
      </div>
    )
  }
}

export default ParcelSearch
